import { Map } from 'immutable';
import DatePicker from 'portaltransparencia-common/components/DatePicker.react.js';
import Input from 'portaltransparencia-common/components/EloInput.react.js';
import Panel from 'portaltransparencia-common/components/Panel.react.js';
import SearchPagination from 'portaltransparencia-common/components/SearchPagination.react.js';
import TableActions from 'portaltransparencia-common/components/TableActions.react.js';
import TableHeader from 'portaltransparencia-common/components/TableHeader.react';
import TableHeaderItem from 'portaltransparencia-common/components/TableHeaderItem.react.js';
import {
  changeFieldValue,
  onChange,
  resetCrud
} from 'portaltransparencia-common/crud/Actions.js';
import {
  addFilterUrl,
  addPagination
} from 'portaltransparencia-common/libs/AddFilter.js';
import DateUtils from 'portaltransparencia-common/libs/DateUtils.js';
import StorageService from 'portaltransparencia-common/libs/StorageService.js';
import { getValueFromUrlSearchParams } from 'portaltransparencia-common/libs/URLUtils.js';
import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row } from 'react-bootstrap';
import Component from 'react-pure-render/component';
import { connect } from 'react-redux';

import FilterButtons from '../components/FilterButtons.react.js';
import PageHeader from '../components/PageHeader.react.js';
import UltimaAtualizacaoByTable from '../ultimaatualizacao/UltimaAtualizacaoByTable.react.js';
import * as actions from './Actions.js';

import { downloadArquivo } from '../arquivo/Actions.js';

export class FormRegulamentacao extends Component {
  static propTypes = {
    page: PropTypes.object.isRequired,
    findRegulamentacoes: PropTypes.func.isRequired,
    filtros: PropTypes.object,
    onChange: PropTypes.func,
    resetCrud: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    changeFieldValue: PropTypes.func.isRequired,
    downloadArquivo: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { findRegulamentacoes, location, changeFieldValue } = this.props;

    const tipo = getValueFromUrlSearchParams(location, 'tipo');
    const ativo = getValueFromUrlSearchParams(location, 'ativo');

    const { entidade } = StorageService.getItem('userInfo');
    let filter = `entidade=${entidade.id}`;

    if (tipo) {
      changeFieldValue('filtroRegulamentacao', 'tipo', tipo);
      filter = addFilterUrl(filter, `tipo=${tipo}`);
    }

    if (ativo !== null) {
      changeFieldValue('filtroRegulamentacao', 'ativo', ativo);
      filter = addFilterUrl(filter, `ativo=${ativo}`);
    }

    findRegulamentacoes(filter);
  }

  onConsultaRegulamentacoes = () => {
    const { page } = this.props;
    const initialPage = page.set('number', 0);

    this.onConsultaWithPage(initialPage);
    this.refs.panelFiltroRegulamentacoes &&
      this.refs.panelFiltroRegulamentacoes.collapse();
  };

  onConsultaWithPage = page => {
    const { findRegulamentacoes } = this.props;
    const filter = this.montaFiltro(page);

    findRegulamentacoes(filter);
  };

  onChangeFiltro = event => {
    const { onChange } = this.props;
    onChange('filtroRegulamentacao', event);
  };

  onResetFiltro = () => {
    const { findRegulamentacoes, resetCrud } = this.props;
    resetCrud('filtroRegulamentacao');

    findRegulamentacoes('');
  };

  montaFiltro = page => {
    const { entidade } = StorageService.getItem('userInfo');
    let filter = `entidade=${entidade.id}`;

    const { filtros } = this.props;

    if (filtros.get('data')) {
      filter = addFilterUrl(filter, `data=${filtros.get('data')}`);
    }
    if (filtros.get('dataValidade')) {
      filter = addFilterUrl(
        filter,
        `dataValidade=${filtros.get('dataValidade')}`
      );
    }
    if (filtros.get('descricao')) {
      filter = addFilterUrl(filter, `descricao=${filtros.get('descricao')}`);
    }
    if (filtros.get('tipo')) {
      filter = addFilterUrl(filter, `tipo=${filtros.get('tipo')}`);
    }
    if (filtros.get('ativo')) {
      filter = addFilterUrl(filter, `ativo=${filtros.get('ativo')}`);
    }

    return addPagination(page, filter);
  };

  renderArquivos = data => {
    const { downloadArquivo } = this.props;

    return (
      <li>
        <a
          style={{ cursor: 'pointer' }}
          onClick={() => downloadArquivo(data.get('arquivoId'))}
        >
          <i className="fa fa-download" style={{ marginRight: '5px' }} />
          {data.get('arquivoNome')}
        </a>
      </li>
    );
  };

  renderRegulamentacao = data => {
    return (
      <TableActions ref="row" key={data.get('id')} data={data}>
        <td>{DateUtils.formatDateTimeShort(data.get('data'))}</td>
        <td>{DateUtils.formatDateTimeShort(data.get('dataValidade'))}</td>
        <td>{data.get('descricao')}</td>
        <td>{data.get('tipo')}</td>
        <td>{data.get('ativo') ? 'Sim' : 'Não'}</td>
        <td>{data.get('arquivos').map(this.renderArquivos)}</td>
      </TableActions>
    );
  };

  render() {
    const { page, filtros, location } = this.props;

    return (
      <section>
        <PageHeader location={location} />

        <Panel
          isForm
          mobileClose
          title="Consulta"
          ref="panelFiltroRegulamentacoes"
        >
          <form>
            <Row>
              <Col xs={6} sm={3} md={3}>
                <DatePicker
                  id="data"
                  name="data"
                  ref="data"
                  placeholder="Data"
                  label="Data"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('data')}
                />
              </Col>
              <Col xs={6} sm={3} md={3}>
                <DatePicker
                  id="dataValidade"
                  name="dataValidade"
                  ref="dataValidade"
                  placeholder="Data de Validade"
                  label="Data de Validade"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('dataValidade')}
                />
              </Col>
              <Col xs={6} sm={3} md={3}>
                <Input
                  id="tipo"
                  name="tipo"
                  ref="tipo"
                  placeholder="Tipo"
                  label="Tipo"
                  type="text"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('tipo')}
                />
              </Col>
              <Col xs={6} sm={3} md={3}>
                <Input
                  id="ativo"
                  name="ativo"
                  ref="ativo"
                  label="Ativo"
                  type="select"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('ativo')}
                >
                  <option value="true">Sim</option>
                  <option value="false">Não</option>
                </Input>
              </Col>
            </Row>
            <Row>
              <Col xs={12} sm={9} md={9}>
                <Input
                  id="descricao"
                  name="descricao"
                  ref="descricao"
                  placeholder="Descrição"
                  label="Descrição"
                  type="text"
                  onChange={this.onChangeFiltro}
                  value={filtros.get('descricao')}
                />
              </Col>
              <Col xs={12} sm={3} md={3}>
                <FilterButtons
                  idBtnReset="btnResetFilter"
                  onConsulta={this.onConsultaRegulamentacoes}
                  onReset={this.onResetFiltro}
                />
              </Col>
            </Row>
          </form>
        </Panel>

        {page?.get('content') && (
          <Panel isForm tableResponsive expansible={false}>
            <Row>
              <Col xs={6}>
                <UltimaAtualizacaoByTable
                  modulo="3"
                  table="regulamentacao"
                  column="dataultimaatualizacao"
                />
              </Col>
              <Col xs={6} />
            </Row>

            <div className="panel-table-outer">
              <table className="panel-table striped fancy">
                <TableHeader
                  empty={page?.get('content').isEmpty()}
                  text="Sem registros"
                >
                  <tr>
                    <TableHeaderItem
                      field="data"
                      label="Data"
                      page={page}
                      searchWithPage={this.onConsultaWithPage}
                      alignment="left"
                    />
                    <TableHeaderItem
                      field="dataValidade"
                      label="Data de Validade"
                      page={page}
                      searchWithPage={this.onConsultaWithPage}
                      alignment="left"
                    />
                    <TableHeaderItem
                      field="descricao"
                      label="Descrição"
                      page={page}
                      searchWithPage={this.onConsultaWithPage}
                      alignment="left"
                    />
                    <TableHeaderItem
                      field="tipo"
                      label="Tipo"
                      page={page}
                      searchWithPage={this.onConsultaWithPage}
                      alignment="left"
                    />
                    <TableHeaderItem
                      field="ativo"
                      label="Ativo"
                      page={page}
                      searchWithPage={this.onConsultaWithPage}
                      alignment="left"
                    />
                    <TableHeaderItem
                      sortable={false}
                      field="arquivos"
                      label="Arquivos"
                      page={page}
                      searchWithPage={this.onConsultaWithPage}
                      alignment="left"
                    />
                  </tr>
                </TableHeader>
                <tbody>
                  {page?.get('content').map(this.renderRegulamentacao)}
                </tbody>
              </table>
            </div>

            <SearchPagination
              page={page}
              searchWithPage={this.onConsultaWithPage}
            />
          </Panel>
        )}
      </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    filtros: state.crud.getIn(
      ['filtroRegulamentacao', 'currentRecord'],
      Map({})
    ),
    page: state.regulamentacoes.get('regulamentacoes')
  };
}

const allActions = {
  ...actions,
  onChange,
  resetCrud,
  changeFieldValue,
  downloadArquivo
};

export default connect(mapStateToProps, allActions)(FormRegulamentacao);
